<template>
  <tr :class="rowClass">
    <td>{{ index + 1 }}</td>

    <td>
      <span v-for="(artist, artistIndex) in track.artists" :key="artistIndex">
        <b-link
            v-if="artist.id"
            :to="{ name: 'artist-view', params: { id: artist.id }}"
            class="font-weight-bold"
        >
          {{ artist.name }}
        </b-link>
        <span v-else>{{ artist.name }}</span>
        <span v-if="artistIndex < track.artists.length - 1">, </span>
      </span>
    </td>

    <td>
      <b-link
          v-if="track.id && $can('view', 'track-view')"
          :to="{ name: 'track-detail', params: { id: track.id }, query: { tab: 'covers' }}"
          class="font-weight-bold"
      >
        {{ track.title }}
      </b-link>
      <span v-else>{{ track.title }}</span>
      <div v-if="track.comment" class="text-muted" style="font-size: 0.85em; font-style: italic;">{{ track.comment }}</div>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          v-if="!track.id"
          variant="warning"
          class="btn-icon ml-50"
          size="sm"
          :disabled="state.isAddingTrack"
          @click="$emit('add-track')"
      >
        <feather-icon icon="PlusIcon" />
      </b-button>
    </td>

    <td>
      <div v-if="track.original_title && !state.isEditing" class="d-flex align-items-center">
        <span>{{ track.original_title }}</span>
        <b-button
            variant="flat-primary"
            class="btn-icon ml-50 p-25"
            size="sm"
            @click="state.isEditing = true"
        >
          <feather-icon icon="EditIcon" size="14" />
        </b-button>
      </div>
      <v-select
          v-else
          v-model="state.selectedOriginal"
          :options="state.searchOptions"
          label="title"
          :filterable="false"
          :loading="state.isSearching"
          @search="(search, loading) => $emit('search', { search, loading })"
          style="min-width: 300px"
      >
        <template #option="option">
          <span>{{ option.title }}</span>
          <b-badge v-if="option.is_cover" variant="light-warning" class="ml-50">cover</b-badge>
          <b-badge v-if="option.has_covers" variant="light-success" class="ml-50">original</b-badge>
        </template>
        <template #no-options>
          Введите для поиска...
        </template>
      </v-select>
    </td>

    <td>
      <span class="text-nowrap">
        <!-- Save original -->
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :variant="state.isSaved ? 'success' : 'primary'"
            class="btn-icon"
            size="sm"
            :disabled="!track.id || !state.selectedOriginal || state.isSaving"
            @click="$emit('save')"
        >
          <feather-icon :icon="state.isSaved ? 'CheckIcon' : 'SaveIcon'" />
        </b-button>

        <!-- Google search -->
        <b-button
            :href="googleSearchUrl"
            variant="info"
            class="btn-icon ml-50"
            size="sm"
            target="_blank"
        >
          <feather-icon icon="GlobeIcon" />
        </b-button>

        <!-- Find original via LLM -->
        <find-original-button
            :query="rowQuery"
            store-namespace="covers"
            allow-apply
            class="ml-50"
            @apply="$emit('apply', $event)"
        />
      </span>
    </td>
  </tr>
</template>

<script>
import { BButton, BLink, BBadge } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { computed } from '@vue/composition-api'
import FindOriginalButton from './FindOriginalButton.vue'

// Строка вынесена в отдельный компонент, чтобы мутации state/track
// перерисовывали только свою строку, а не всю таблицу
export default {
  components: {
    BButton,
    BLink,
    BBadge,
    vSelect,
    FindOriginalButton,
  },
  directives: {
    Ripple,
  },
  props: {
    track: {
      type: Object,
      required: true,
    },
    state: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const rowClass = computed(() => {
      if (props.track.original_track_id) return 'table-warning'
      if (props.track.has_covers) return 'table-success'
      return ''
    })

    const firstArtistName = computed(() => (props.track.artists && props.track.artists[0] ? props.track.artists[0].name : ''))

    const googleSearchUrl = computed(() => {
      const query = `${firstArtistName.value} ${props.track.title} оригинал песни кавер чья песня`
      return `https://www.google.com/search?q=${encodeURIComponent(query)}`
    })

    const rowQuery = computed(() => `${firstArtistName.value} - ${props.track.title}`)

    return {
      rowClass,
      googleSearchUrl,
      rowQuery,
    }
  },
}
</script>
